import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: 'oklch(var(--background-900))', color: 'oklch(var(--background-100))' }}>
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-seedling-line text-2xl" style={{ color: 'oklch(var(--primary-400))' }}></i>
                </div>
                <span className="text-lg font-heading text-background-50">雏鸟</span>
              </div>
              <p className="text-sm leading-relaxed" style={{ color: 'oklch(var(--background-300))' }}>
                专为年轻用户打造的社交成长平台。在这里找到志同道合的伙伴，分享你的精彩生活，一起成长。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold mb-4 text-background-50">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>首页</Link>
                <Link to="/category/feature-intro" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>功能介绍</Link>
                <Link to="/category/tutorial" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>使用教程</Link>
                <Link to="/category/download" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>下载指南</Link>
                <Link to="/about" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold mb-4 text-background-50">帮助支持</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/faq" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>常见问题</Link>
                <Link to="/category/tutorial" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>新手指南</Link>
                <Link to="/article/article-6" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>隐私安全</Link>
                <Link to="/about#contact" className="text-sm hover:underline" style={{ color: 'oklch(var(--background-300))' }}>联系我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold mb-4 text-background-50">关注我们</h4>
              <div className="flex gap-4 mb-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200" style={{ backgroundColor: 'oklch(var(--background-700))' }} aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-base" style={{ color: 'oklch(var(--background-200))' }}></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200" style={{ backgroundColor: 'oklch(var(--background-700))' }} aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-base" style={{ color: 'oklch(var(--background-200))' }}></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200" style={{ backgroundColor: 'oklch(var(--background-700))' }} aria-label="小红书" rel="nofollow">
                  <i className="ri-red-packet-line text-base" style={{ color: 'oklch(var(--background-200))' }}></i>
                </a>
              </div>
              <p className="text-xs" style={{ color: 'oklch(var(--background-400))' }}>
                客服邮箱：support@chuniao.app
              </p>
              <p className="text-xs mt-1" style={{ color: 'oklch(var(--background-400))' }}>
                工作时间：周一至周日 9:00-21:00
              </p>
            </div>
          </div>

          <div className="border-t mt-10 pt-6" style={{ borderColor: 'oklch(var(--background-700))' }}>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs" style={{ color: 'oklch(var(--background-500))' }}>
                &copy; {new Date().getFullYear()} 雏鸟科技 版权所有 | 粤ICP备XXXXXXXX号
              </p>
              <div className="flex gap-4">
                <a href="#" className="text-xs hover:underline" style={{ color: 'oklch(var(--background-500))' }}>用户协议</a>
                <a href="#" className="text-xs hover:underline" style={{ color: 'oklch(var(--background-500))' }}>隐私政策</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}